import type { ExceptionField } from '@/api/cockpit';
import { resolveMatchedFieldValue } from './resolve-matched-field-value';
import { formatMatchedSelectOptionLabel } from './format-matched-select-option-label';

export function resolveMatchedFieldLabel(
  field: ExceptionField,
  fields: Record<string, string>,
): string {
  const value = resolveMatchedFieldValue(field, fields);
  if (!value) return '';
  const option = field.matchedOptions?.find((candidate) => candidate.value === value);
  if (option) return formatMatchedSelectOptionLabel(field, option);
  return field.matchedDisplayValue ?? value;
}
